module.exports = __webpack_public_path__ + "static/pro_fct2-bcf4878f9578ffe7978c2cf6eef2cc72.jpg";